<div class="summary-container" *ngIf="!loading && summary" [style.--summary-legend-color]="colorCoolGrey">
  <div class="summary-card" *ngIf="showUnpublishedCard" (click)="routeToUnpublished()">
    <div class="summary-card-header">
      <i class="fa-solid fa-eye-slash summary-card-icon"></i>
      <span class="summary-card-number">{{ unpublishedTotal | number }}</span>
    </div>
    <div class="summary-card-title">Não publicados</div>
    <div class="summary-card-legends">
      <span class="summary-pill" *ngIf="summary.neverPublished" (click)="routeToNeverPublished($event)">
        {{ summary.neverPublished | number }} nunca publicado{{ summary.neverPublished !== 1 ? 's' : '' }}
      </span>
      <span class="summary-pill" *ngIf="summary.inactivated" (click)="routeToInactivated($event)">
        {{ summary.inactivated | number }} inativado{{ summary.inactivated !== 1 ? 's' : '' }}
      </span>
    </div>
  </div>

  <div class="summary-card" *ngIf="showPublishedCard" (click)="routeToPublished()">
    <div class="summary-card-header">
      <i class="app-icon-tag summary-card-icon"></i>
      <span class="summary-card-number">{{ summary.published | number }}</span>
    </div>
    <div class="summary-card-title">Publicados</div>
    <div class="summary-card-legends">
      <span class="summary-pill" *ngIf="summary.fastQuote" (click)="routeToFastQuote($event)">
        {{ summary.fastQuote | number }} em cotação rápida
      </span>
      <span class="summary-pill" *ngIf="summary.integratedSuperbid" (click)="routeToIntegratedSuperbid($event)">
        {{ summary.integratedSuperbid | number }} integrado{{ summary.integratedSuperbid !== 1 ? 's' : '' }} na Superbid
      </span>
      <span class="summary-pill" *ngIf="summary.republishedMultipleTimes" (click)="routeToRepublishedMultipleTimes($event)">
        {{ summary.republishedMultipleTimes | number }} republicado{{ summary.republishedMultipleTimes !== 1 ? 's' : '' }} várias vezes
      </span>
    </div>
  </div>

  <div class="summary-card" *ngIf="showOffersCard" (click)="routeToOffers()">
    <div class="summary-card-header">
      <i class="admin-icon-balao-dolar summary-card-icon"></i>
      <span class="summary-card-number">{{ offersTotal | number }}</span>
    </div>
    <div class="summary-card-title">Ofertas</div>
    <div class="summary-card-legends">
      <span class="summary-pill" *ngIf="summary.withOffer" (click)="routeToWaitingClosing($event)">
        {{ summary.withOffer | number }} aguardando encerramento
      </span>
      <span class="summary-pill summary-pill-link" *ngIf="summary.withPersonalizedOffer" (click)="routeToWithPersonalizedOffer($event)">
        {{ summary.withPersonalizedOffer | number }} com oferta personalizada
      </span>
      <span class="summary-pill summary-pill-link" *ngIf="summary.withConditionalOffer" (click)="routeToWithConditionalOffer($event)">
        {{ summary.withConditionalOffer | number }} com oferta condicional
      </span>
    </div>
  </div>

  <div class="summary-card" *ngIf="showSoldCard" (click)="routeToSold()">
    <div class="summary-card-header">
      <i class="admin-icon-new-arramatar summary-card-icon"></i>
      <span class="summary-card-number">{{ summary.soldThisMonth | number }}</span>
    </div>
    <div class="summary-card-title">Vendas do mês atual</div>
    <div class="summary-card-legends">
      <span class="summary-pill" *ngIf="summary.soldToday" (click)="routeToSoldTodayReport($event)">
        {{ summary.soldToday | number }} venda{{ summary.soldToday !== 1 ? 's' : '' }} hoje
      </span>
      <span class="summary-pill summary-pill-warning" *ngIf="summary.soldWithPendingPayment" (click)="routeToSoldWithPendingPayment($event)">
        {{ summary.soldWithPendingPayment | number }} com fee plataforma pendente
      </span>
    </div>
  </div>
</div>
